import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NovaPessoa} from "../../../models/nova-pessoa";
import {CadastrosGeraisService} from "../../../services/cadastros-gerais.service";
import {TipoDocumentoCliente} from "../../../gerais/models/tipo-documento-cliente";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {ClienteService} from "../../../services/cliente.service";

@Component({
    selector: 'app-novo-cliente',
    templateUrl: './novo-cliente.component.html',
    styleUrl: './novo-cliente.component.css',
    standalone: false
})
export class NovoClienteComponent {
  @Input() habilitarNovo = false;
  @Output() fecharModalCalled = new EventEmitter();
  @Output() atualizarListaCalled = new EventEmitter();

  tipoDocumentos: TipoDocumentoCliente[] = [];
  novoCliente = new NovaPessoa();
  formAdicionarCliente: FormGroup;
  mascaraDocumento = '';
  loading = false;

  constructor(private tipoDocumentoService: CadastrosGeraisService,
              private toastr: ToastrService,
              private clienteService: ClienteService,
              private formBuilder: FormBuilder) {
     this.buscarListaTipoDocumentos();
     this.construirFormulario();
  }

  fecharModalNovo(){
    this.fecharModalCalled.emit();
  }

  atualizarLista(){
    this.atualizarListaCalled.emit();
  }

  buscarListaTipoDocumentos() {
    this.tipoDocumentoService.selecionarListaTipoDocumentosCliente().subscribe(resultado => {
      if(resultado.sucesso){
        this.tipoDocumentos = resultado.dados
      }
    });
  }

  cancelar(){
    this.formAdicionarCliente.reset();
    this.fecharModalNovo();
  }

  habilitarDocumento(){
    let tipoDocumento = this.tipoDocumentos
              .find(x => x.id == this.formAdicionarCliente.controls['tipoDocumento'].value)
    if(this.formAdicionarCliente.controls['tipoDocumento'].value != 0){
      this.formAdicionarCliente.controls['documento'].enable();
      this.formAdicionarCliente.controls['documento'].reset();
    }
    else{
      this.formAdicionarCliente.controls['documento'].disable();
      this.formAdicionarCliente.controls['documento'].reset();
    }

    if(tipoDocumento != undefined) {
      if(tipoDocumento.descricao.toUpperCase().includes("CPF")) {
        this.mascaraDocumento = "000.000.000-00";
      }else if(tipoDocumento.descricao.toUpperCase().includes("CNPJ")){
        this.mascaraDocumento = "00.000.000/0000-00";
      }else if(tipoDocumento.descricao.toUpperCase().includes("RG")){
        this.mascaraDocumento = "00.000.000-0";
      }
    }
  }

  salvar(){
    this.loading = true;
    if(this.formAdicionarCliente.valid){
      this.preencherCliente();
      this.clienteService.adicionar(this.novoCliente).subscribe(retorno => {
        if(retorno.sucesso) {
          this.toastr.success("Cliente salvo com sucesso.");
          this.cancelar();
          this.atualizarLista();
        }
        else{
          this.toastr.error(retorno.errors[0].mensagem);
        }
        this.loading = false;
      }, error => {
        if(error.errors != undefined){
          this.toastr.error(error.errors[0].mensagem);
        }else{
          this.toastr.error("Não foi possível salvar o cliente");
        }
        this.loading = false;
      });
    } else{
      Object.keys(this.formAdicionarCliente.controls).forEach(name => {
        const control = this.formAdicionarCliente.controls[name];
        control.markAsDirty();
        control.markAsTouched();
        control.updateValueAndValidity();
      });
      this.loading = false;
      this.toastr.error("Verifique os campos pois estão inválidos");
    }
  }

  private preencherCliente(){
    this.novoCliente.nome = this.formAdicionarCliente.controls['nome'].value;
    this.novoCliente.documento = this.formAdicionarCliente.controls['documento'].value;
    this.novoCliente.tipoDocumento = this.formAdicionarCliente.controls['tipoDocumento'].value || null;
    this.novoCliente.telefone = this.formAdicionarCliente.controls['telefone'].value;
  }

  private construirFormulario(){
    this.formAdicionarCliente = this.formBuilder.group({
      nome: ['', Validators.required],
      telefone: ['', Validators.required],
      documento: ['', Validators.required],
      tipoDocumento: [null, Validators.required]
    });
    this.formAdicionarCliente.controls['documento'].disable();
  }
}
